import { useEffect } from 'react';
import { subscribeTagReads } from '../services/scannerService';
import { useDocumentWizardStore } from '../stores/documentWizardStore';

/** Wire hardware TagRead events into wizard tag pool while enabled (scan screen + connected). */
export function useScannerTagSubscription(enabled: boolean) {
  const ingestTag = useDocumentWizardStore((s) => s.ingestTag);

  useEffect(() => {
    if (!enabled) return;
    return subscribeTagReads((tagId) => ingestTag(tagId));
  }, [enabled, ingestTag]);
}
